// We reserve Controller for the export name
import {Controller as BaseController} from "@hotwired/stimulus";

export default class extends BaseController {
    connect() {}
}